import { createApp, h } from 'vue'

import './style.css'
import App from './App.vue'
import router from './router'

const app = createApp(App)

// 注入全局通用样式
import './assets/css/common.scss';

// 注入moment时间格式化包
import moment from "moment";
import 'moment/locale/zh-cn'; // 引入中文语言包
moment.locale('zh-cn'); // 设置全局语言为简体中文

// 注入pinia
import {createPinia} from "pinia"
const pinia = createPinia()
// pinia持久化
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
pinia.use(piniaPluginPersistedstate)

app.use(pinia)

// 注入Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
// 设置本地为zh
import { pl, zhHans } from "vuetify/locale";
// 注入mdi图标库
import "@mdi/font/css/materialdesignicons.css";
const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: "light",
    },
    locale: {
        locale: "zhHans",
        messages: { zhHans, pl },
    }
});

// 注入element-plus message样式
import 'element-plus/theme-chalk/el-message.css'

// 注入全局变量
app.config.globalProperties.$globalPageSize = 20;
app.config.globalProperties.$globalPageSizeHalf = 10;

// 注入全局函数判断是否拥有权限
import {hasBtnPermission} from "@/hooks/permission.js";
app.config.globalProperties.$handleHasBtnPermission = hasBtnPermission;

// el-select选择器下拉图标
const SelectArrowDown = {
    render() {
        return h('img', {
            src: new URL('@/assets/images/filter/select-arrowDown.svg', import.meta.url).href,
            style: 'width: 14px; height: 14px;',
        })
    },
}
// 全局注入选择器下拉图标
app.config.globalProperties.$SelectArrowDown = SelectArrowDown

app.use(router)
app.use(vuetify)
app.mount("#app");
